import script from "./PostCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PostCard.vue?vue&type=script&setup=true&lang=js"

import "./PostCard.vue?vue&type=style&index=0&id=3d48377c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d48377c"]])

export default __exports__